/* section-bd-product.js — interactions V3 de la fiche produit (T15).
 Combo preview : suit les swatches natifs Dawn (délégation sur document,
 survit aux re-renders de product-info). Générique : N options couleur. */
(function () {
 function updateCombos() {
 var bdLang = (document.documentElement.lang || '').toLowerCase().slice(0, 2);
 var isDe = bdLang === 'de', isFr = bdLang === 'fr';
 document.querySelectorAll('[data-bd-combo]').forEach(function (combo) {
 var scope = combo.closest('product-info') || document;
 var checked = scope.querySelectorAll('fieldset.product-form__input--swatch input:checked');
 // Dédupliqué par nom d'option : le re-render product-info peut faire
 // coexister brièvement deux pickers — la dernière valeur gagne.
 var byOption = new Map();
 checked.forEach(function (input) {
 // Les line item properties (ex. Day letters color) ne sont pas des
 // options de variante : leur combo est piloté par bd-day-letters.
 if ((input.name || '').indexOf('properties[') === 0) return;
 var key = input.dataset.optionName || input.name;
 var labelEl = input.nextElementSibling;
 var swatchEl = labelEl && labelEl.querySelector ? labelEl.querySelector('.swatch') : null;
 var bg = swatchEl ? getComputedStyle(swatchEl).getPropertyValue('--swatch--background').trim() : '';
 var existing = byOption.get(key);
 // « White lid · Blue base » : le nom d'option moins « color / couleur /
 // farbe » (+ articles FR/DE) = le nom de la pièce. Minuscules en EN/FR,
 // le DE garde la majuscule de ses substantifs (Deckel, Basis).
 var noun = key.replace(/-\d+$/, '').replace(/colou?r|couleur|farbe/gi, '')
 .replace(/\b(de la|du|de|der|des)\b/gi, '').replace(/\s+/g, ' ').trim();
 if (!isDe) noun = noun.toLowerCase();
 byOption.set(key, { value: input.value, noun: noun, bg: bg || (existing ? existing.bg : '') });
 });
 var entries = Array.from(byOption.values());
 entries.forEach(function (entry, i) {
 var chip = combo.querySelector('[data-bd-combo-chip="' + i + '"]');
 if (chip && entry.bg) chip.style.background = entry.bg;
 });
 var nameEl = combo.querySelector('[data-bd-combo-name]');
 // Combo « 3 pastilles » (weekly-compact) : le texte inclut la couleur
 // des lettres et appartient à bd-day-letters — ne pas l'écraser.
 if (combo.querySelector('[data-bd-writing-chip]')) nameEl = null;
 if (nameEl && entries.length) {
 nameEl.textContent = entries
 .map(function (e) {
 if (!e.noun) return e.value;
 // DE « Deckel Weiß », FR « Couvercle blanc · Base noire » (accord féminin de la base), EN « White lid »
 if (isDe) return e.noun + ' ' + e.value;
 if (isFr) {
 var v = e.value.toLowerCase();
 if (e.noun === 'base') v = v.replace(/^blanc$/, 'blanche').replace(/^noir$/, 'noire').replace(/^bleu$/, 'bleue');
 return e.noun.charAt(0).toUpperCase() + e.noun.slice(1) + ' ' + v;
 }
 return e.value + ' ' + e.noun;
 })
 .join(' · ');
 }
 });
 }

 /* Note « noir mat » conditionnelle (handoff 05/09) : visible si un swatch
 sélectionné est #000000 (couvercle OU base). Test par le hex, jamais par
 le libellé (Black/Noir/Schwarz). */
 function updateBlackNote() {
 document.querySelectorAll('[data-bd-blacknote]').forEach(function (note) {
 var scope = note.closest('product-info') || document;
 var black = false;
 scope.querySelectorAll('fieldset.product-form__input--swatch input:checked').forEach(function (input) {
 if ((input.name || '').indexOf('properties[') === 0) return;
 var labelEl = input.nextElementSibling;
 var swatchEl = labelEl && labelEl.querySelector ? labelEl.querySelector('.swatch') : null;
 var bg = swatchEl ? getComputedStyle(swatchEl).getPropertyValue('--swatch--background').trim().toLowerCase() : '';
 var norm = bg.replace(/[\s,]/g, '');
 if (norm === '#000000' || norm === '#000' || norm === 'rgb(000)' || norm === 'rgb(0,0,0)'.replace(/,/g, '')) black = true;
 });
 note.classList.toggle('is-on', black);
 });
 }

 document.addEventListener('change', function (e) {
 if (e.target && e.target.matches && e.target.matches('.product-form__input--swatch input')) {
 window.setTimeout(updateCombos, 30);
 window.setTimeout(updateBlackNote, 30);
 }
 });
 if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', updateBlackNote);
 else updateBlackNote();

 /* Sticky ATC mobile — pattern PORTAL : barre séparée montée sur <body>
 (immunisée aux ancêtres transform/sticky qui cassent position:fixed sur
 iOS), bouton proxy qui clique le vrai submit du form. On observe le bloc
 de boutons réel (hauteur non nulle, jamais déplacé) : zéro boucle. */
 function initStickyAtc() {
 if (document.querySelector('.bd-atc-bar')) return;
 var productInfo = document.querySelector('product-info');
 if (!productInfo) return;
 var buttons = productInfo.querySelector('.product-form__buttons');
 var realBtn = productInfo.querySelector('.product-form__submit');
 if (!buttons || !realBtn) return;

 var bar = document.createElement('div');
 bar.className = 'bd-atc-bar';
 bar.hidden = true;
 var btn = document.createElement('button');
 btn.type = 'button';
 btn.className = 'bd-atc-bar__btn';
 btn.addEventListener('click', function () {
 var current = document.querySelector('product-info .product-form__submit');
 if (current && !current.disabled) current.click();
 });
 bar.appendChild(btn);
 document.body.appendChild(bar);

 function sync() {
 var current = document.querySelector('product-info .product-form__submit');
 if (!current) return;
 var label = (current.textContent || '').trim().split('\n')[0].trim();
 if (label) btn.textContent = label;
 btn.disabled = current.disabled || current.getAttribute('aria-disabled') === 'true';
 }
 sync();

 new IntersectionObserver(function (entries) {
 var e = entries[0];
 var out = !e.isIntersecting && e.boundingClientRect.top < 0;
 bar.hidden = !out;
 if (out) sync();
 }).observe(buttons);

 document.addEventListener('change', function () {
 window.setTimeout(sync, 250);
 });
 }

 /* Mobile : prix inliné dans le titre (« Titre · CHF 7.50 »). On déplace le
 bloc prix natif (il garde son id → les updates de variante Dawn suivent),
 marqueur de position pour restaurer en desktop (rotation/resize). */
 function initInlinePrice() {
 var priceBlock = document.querySelector('product-info [id^="price-"]');
 var heading = document.querySelector('product-info .product__title > h1, product-info .product__title > h2');
 if (!priceBlock || !heading || priceBlock.dataset.bdInlineInit) return;
 priceBlock.dataset.bdInlineInit = '1';
 var placeholder = document.createComment('bd-price-home');
 priceBlock.parentNode.insertBefore(placeholder, priceBlock);
 var dot = document.createElement('span');
 dot.className = 'bd-title-price-dot';
 dot.setAttribute('aria-hidden', 'true');
 dot.textContent = ' · ';
 var mq = window.matchMedia('(max-width: 749px)');
 function apply() {
 if (mq.matches) {
 heading.appendChild(dot);
 heading.appendChild(priceBlock);
 priceBlock.classList.add('bd-title-price');
 } else if (priceBlock.classList.contains('bd-title-price')) {
 priceBlock.classList.remove('bd-title-price');
 if (dot.parentNode) dot.parentNode.removeChild(dot);
 placeholder.parentNode.insertBefore(priceBlock, placeholder.nextSibling);
 }
 }
 apply();
 if (mq.addEventListener) mq.addEventListener('change', apply);
 else if (mq.addListener) mq.addListener(apply);
 }

 function init() {
 updateCombos();
 initStickyAtc();
 initInlinePrice();
 }

 if (document.readyState === 'loading') {
 document.addEventListener('DOMContentLoaded', init);
 } else {
 init();
 }
})();
